import { render, staticRenderFns } from "./ResultsHeaderContainer.vue?vue&type=template&id=30d8bea2&"
import script from "./ResultsHeaderContainer.vue?vue&type=script&lang=ts&"
export * from "./ResultsHeaderContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports